import { FormattedMessage } from 'react-intl';
import { Tag } from 'antd';

import Icon from '../../../components/Icon/Icon';
import Spinner from '../../../components/Spinner/Spinner';

import useProfileTab from './useProfileTab';

import { Props, TabStatus } from './ProfileTab.model';

import styles from './ProfileTab.module.scss';


const ProfileTab = ({
	i18nCountries,
	id,
	introduction,
	formatDate,
	mentoringScopes,
	reviews,
	role,
	showReviews,
}: Props) => {

	const {
		state: {
			education,
			tabStatus,
			workExperience,
		}
	} = useProfileTab({ id });

	const renderChips = (chips: string[], category?: string) => {
		return chips.map((field: string, index: number) => (<Tag
			key={`${field}${index}`}
			style={{
				border: 'none',
				textTransform: 'uppercase'
			}}>{category ? <FormattedMessage id={`${category}.${field}`} /> : field}</Tag>))
	}
	
	const renderEducation = () => {
		return <div className={styles.experienceWrapper}>{education?.map((ed, index: number) => (
			<div className={styles.workExperience} key={ed.educationId}>
				<div className={styles.expPeriod}>
					{formatDate(ed.startDate)} -{" "}
					{ed.endDate ? (
						formatDate(ed.endDate)
					) : (
						<FormattedMessage id="basics.present" />
					)}
				</div>
				<div className={styles.expPosition}>
					<b>{ed.obtainedDegree} </b>
					<FormattedMessage id="basics.at" />
					<b> {ed.institution}</b>, {i18nCountries[ed.location]}
					<br />
					<span className={styles.description}>{ed.description}</span>
				</div>
			</div>))} </div>
	}

	const renderResearchExperience = () => {
		return <div className={styles.experienceWrapper}>{workExperience?.map((experience, index: number) => (
			<div className={styles.workExperience} key={experience.workExperienceId}>
				<div className={styles.expPeriod}>
					{formatDate(experience.startDate)} -{" "}
					{experience.endDate ? (
						formatDate(experience.endDate)
					) : (
						<FormattedMessage id="basics.present" />
					)}
				</div>
				<div className={styles.expPosition}>
					<b><FormattedMessage id={`currentPosition.${experience.currentPosition}`} /> </b>
					<FormattedMessage id="basics.at" />
					<b> {experience.institution}</b>, {i18nCountries[experience.location]}
					<br />
					<span className={styles.description}>{experience.description}</span>
				</div>
			</div>))} </div>
	}

	return (
		<div className={styles.tabContent}>
			<Spinner spinning={tabStatus === TabStatus.Loading} />
			<div className={styles.category}>
				<div className={styles.categoryTitle}>
					<Icon
						name="user-tie"
						color="light"
						width="18"
						height="18"
						className={styles.icon}
					/>
					<h2><FormattedMessage id="userLabels.introduction" /></h2>
				</div>
				<div className={styles.categoryContent}>
					{introduction ? <p>{introduction}</p> : <div><FormattedMessage id="userLabels.placeholder" /></div>}
				</div>
			</div>
		{role === 'Mentor' &&	<div className={styles.category}>
				<div className={styles.categoryTitle}>
					<Icon
						name="user-tie"
						color="light"
						width="18"
						height="18"
						className={styles.icon}
					/>
					<h2><FormattedMessage id="userLabels.mentoringScopes" /></h2>
				</div>
				<div className={styles.categoryContent}>
					{mentoringScopes ? <div className={styles.tags}>{ renderChips(mentoringScopes, 'mentoringScopes')} </div> : <div><FormattedMessage id="userLabels.placeholder" /></div>}
				</div>
			</div>}

			<div className={styles.category}>
				<div className={styles.categoryTitle}>
					<Icon
						name="flask-potion"
						color="light"
						width="18"
						height="18"
						className={styles.icon}
					/>
					<h2><FormattedMessage id="userLabels.workExperience" /></h2>
				</div>
				<div className={styles.categoryContent}>
					{workExperience && workExperience[0] ? renderResearchExperience() : <div><FormattedMessage id="userLabels.placeholder" /></div>}
				</div>
			</div>
			<div className={styles.category}>
				<div className={styles.categoryTitle}>
					<Icon
						name="graduation-cap"
						color="light"
						width="18"
						height="18"
						className={styles.icon}
					/>
					<h2><FormattedMessage id="userLabels.education" /></h2>
				</div>
				<div className={styles.categoryContent}>
					{education && education[0] ? renderEducation() : <div><FormattedMessage id="userLabels.placeholder" /></div>}
				</div>
			</div>
			{showReviews && <div className={styles.category}>
				<div className={styles.categoryTitle}>
					<Icon
						name="user-tie"
						color="light"
						width="18"
						height="18"
						className={styles.icon}
					/>
					<h2><FormattedMessage id="userLabels.reviews" /></h2>
				</div>
				<div className={styles.categoryContent}>
					{reviews}
				</div>
			</div>}
		</div>
	);
}

export default ProfileTab;